// extracted by mini-css-extract-plugin
export default {"panel":"Panel-module__panel__6pzP3","opened":"Panel-module__opened__UsZsc","content":"Panel-module__content__E56Sf"};